"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useInfoMessage = void 0;
var _useTranslations = require("./useTranslations");
const useInfoMessage = itemCount => {
  const {
    formatMessage
  } = (0, _useTranslations.useTranslations)();
  if (itemCount === 0) {
    return formatMessage('allInStock');
  }
  return `${itemCount} ${formatMessage(itemCount > 1 ? 'products' : 'product')} ${formatMessage('notInStock')}`;
};
exports.useInfoMessage = useInfoMessage;